import DOMPurify from 'dompurify'
import { Suspense } from 'react'
import { Helmet } from 'react-helmet'
import { RenderClient } from 'src/components/RenderClient'

import type { Props } from './raw-code-render'

const RawCodeRender = ({ contentCSS, contentHTML, contentJS }: Props) => {
  const cleanedCSS = DOMPurify.sanitize(contentCSS)
  const cleanedHTML = DOMPurify.sanitize(contentHTML, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'sandbox'],
  })

  let code = ''

  if (cleanedCSS !== '') {
    // We must exclude the 'font-family' directives coming from this component, because they override the rules we set in the code
    const finalCSS = cleanedCSS.replace(/font-family:\s*([^;]+)/g, '')

    code = code.concat(`<style> ${finalCSS}</style>`)
  }

  code = code.concat(cleanedHTML)

  return (
    <>
      <Helmet>
        <script type="module">{contentJS}</script>
      </Helmet>
      <div dangerouslySetInnerHTML={{ __html: code }} />
    </>
  )
}

const RawCodeRenderWrapper = ({
  contentCSS,
  contentHTML,
  contentJS,
}: Props) => {
  return (
    <Suspense fallback={<></>}>
      <RenderClient>
        <RawCodeRender
          contentCSS={contentCSS}
          contentHTML={contentHTML}
          contentJS={contentJS}
        />
      </RenderClient>
    </Suspense>
  )
}

export default RawCodeRenderWrapper
